import { absolutePath } from "../../../absolutePath";

interface UpdateSessionStepParams {
  paywallId: number;
  stepId: number;
}

interface UpgradePreviewParams {
  couponMode: "policy" | "without_coupon";
  paywallId: number;
  requestId: string;
  selectedPaywallPriceId?: number;
  stepId: number;
}

export const sessionStep = {
  update: ({ stepId, paywallId }: UpdateSessionStepParams): string =>
    absolutePath(`paywalls/checkout/session_steps/${stepId}`, {
      paywall_id: paywallId,
    }),
  decline: (stepId: string | number): string =>
    absolutePath(`paywalls/checkout/session_steps/${stepId}/decline`),
  acceptUpgrade: ({ paywallId, stepId }: UpdateSessionStepParams): string =>
    absolutePath(`paywalls/checkout/session_steps/${stepId}/accept_upgrade`, {
      paywall_id: paywallId,
    }),
  upgradePreview: ({
    couponMode,
    paywallId,
    requestId,
    selectedPaywallPriceId,
    stepId,
  }: UpgradePreviewParams): string =>
    absolutePath(`paywalls/checkout/session_steps/${stepId}/upgrade_preview`, {
      paywall_id: paywallId,
      request_id: requestId,
      ...(selectedPaywallPriceId === undefined
        ? {}
        : { selected_paywall_price_id: selectedPaywallPriceId }),
      coupon_mode: couponMode,
    }),
};
